import React from 'react';
import {
  Table,
  TableBody,
  DataTableCell,
} from '@david.kucsai/react-pdf-table';
import { Text } from '@react-pdf/renderer';
import { lightGray, styles } from './pdfStyles';

const balanceSheetStyles = {
  container: {
    marginTop: '10mm',
    marginBottom: '10mm'
  },
  title: {
    ...styles.h2,
    marginBottom: '5mm'
  },
  tableHead: {
    borderWidth: '0pt',
    backgroundColor: lightGray,
    fontSize: 9,
    fontWeight: 600,
  },
  tableCell: {
    borderWidth: '0pt',
    fontSize: 9,
    paddingTop: '0.5mm',
    paddingBottom: '0.5mm',
    paddingLeft: '1mm'
  },
  tableCellRight: {
    borderWidth: '0pt',
    fontSize: 9,
    textAlign: 'right',
    paddingTop: '0.5mm',
    paddingBottom: '0.5mm',
    paddingLeft: '1mm'
  }
};

const MONTH_NAMES_PDF = [
  'JANEIRO',
  'FEVEREIRO',
  'MARÇO',
  'ABRIL',
  'MAIO',
  'JUNHO',
  'JULHO',
  'AGOSTO',
  'SETEMBRO',
  'OUTUBRO',
  'NOVEMBRO',
  'DEZEMBRO'
];

const formatCurrencyPdf = (amount) => {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return formatter.format(amount);
};

const getMonthYearLabelPdf = (month, year) => {
  if (!month || !year) return '';
  const monthName = MONTH_NAMES_PDF[month - 1] || '';
  return `${monthName}/${year % 100}`;
};

const buildPdfBalanceSheetDataStandard = (balance) => {
  const data = [];

  if (!balance) return data;

  const {
    bankAccount,
    incomeBalanceAmount = 0,
    expenseBalanceAmount = 0,
    transferBalanceAmount = 0,
    monthBalanceAmount = 0,
    year,
    month
  } = balance;

  // Header row with bank account and month/year
  const bankAccountName = bankAccount?.name || 'Conta Corrente';
  const monthYearLabel = getMonthYearLabelPdf(month, year);
  data.push({ item: bankAccountName, value: monthYearLabel, isHeader: false });

  // Calculate initial balance
  const initialBalance = monthBalanceAmount - (incomeBalanceAmount + expenseBalanceAmount + transferBalanceAmount);
  data.push({
    item: 'Saldo Inicial',
    value: formatCurrencyPdf(initialBalance),
    isHeader: true
  });

  // Income row
  data.push({
    item: 'Receitas',
    value: formatCurrencyPdf(incomeBalanceAmount),
    isHeader: true
  });

  // Expenses row
  data.push({
    item: 'Despesas',
    value: formatCurrencyPdf(expenseBalanceAmount),
    isHeader: true
  });

  // Transfers row
  data.push({
    item: 'Transferências',
    value: formatCurrencyPdf(transferBalanceAmount),
    isHeader: true
  });

  // Final balance row
  data.push({
    item: 'Saldo Final',
    value: formatCurrencyPdf(monthBalanceAmount),
    isHeader: true
  });

  return data;
};

export const PdfBalanceSheetStandard = ({ dataBilling }) => {
  const balance = dataBilling?.balance;
  const balanceSheetData = buildPdfBalanceSheetDataStandard(balance);

  if (!balanceSheetData || balanceSheetData.length === 0) {
    return null;
  }

  const tableCellOptions = {
    includeLeftBorder: false,
    includeTopBorder: false,
    includeRightBorder: false,
    includeBottomBorder: false
  };

  return (
      <Table data={balanceSheetData}>
        <TableBody {...tableCellOptions}>
            <DataTableCell
                style={balanceSheetStyles.tableCell}
                weighting={0.60}
                getContent={(r) => {
                let cellStyle = {...balanceSheetStyles.tableCell};
                
                if (r.isHeader) {
                    cellStyle = { ...cellStyle, fontWeight: 'bold' };
                }
                
                return (
                    <Text style={{...cellStyle}}>
                    {r.item}
                    </Text>
                );
                }}
            />
            <DataTableCell
                style={balanceSheetStyles.tableCell}
                weighting={0.40}
                getContent={(r) => 
                {
                let cellStyle = {...balanceSheetStyles.tableCellRight};

                if (r.isHeader) {
                    cellStyle = { ...cellStyle, fontWeight: 'bold' };
                }
                
                return (
                    <Text style={cellStyle}>
                    {r.value}
                    </Text>
                );
                }
                }
            />
        </TableBody>
      </Table>
  );
};
